import { PencilIcon } from '@grupoboticario/flora-react-icons';
import { CardInfo } from '../../sharedStyles';

import { CardInfoTitleSummary, EditButton, CardInfoFields } from '../styles';

interface ICardSummary {
  editStep?: any;
  stateClaim: any;
}

export const Card05 = ({ editStep, stateClaim }: ICardSummary): JSX.Element => {
  return (
    <CardInfo>
      <CardInfoTitleSummary>
        Dados do Responsável pelo sinistro
        {editStep && (
          <EditButton
            size="small"
            has="iconLeft"
            icon={<PencilIcon />}
            onClick={() => editStep(3)}
          >
            Editar
          </EditButton>
        )}
      </CardInfoTitleSummary>
      <CardInfoFields>
        <span className="singleLine">Responsável pelo sinistro:</span>
        <p className="singleLine">{stateClaim.step.step3?.accountable}</p>
        <hr />
        <span className="singleLine">Email:</span>
        <p className="singleLine">{stateClaim.step.step3?.email}</p>
        <hr />
        <span className="singleLine">Celular:</span>
        <p className="singleLine">{stateClaim.step.step3?.cellphone}</p>
        <hr />
        <span className="singleLine">Tel. Comercial:</span>
        <p className="singleLine">
          {stateClaim.step.step3?.businessphone || '-'}
        </p>
      </CardInfoFields>
    </CardInfo>
  );
};
